import React from 'react';

import '../spacewarp.css'; 

 const Loader = () => {
     return (
        <div class="loader">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>
     )}

 
 export default Loader

